import * as React from 'react'
import { CurrentCompanyStore } from '../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Currency } from './Currency'
import { convertLoyaltyPointsToCents } from '@getgreenline/loyalties'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd-v4'

interface Props {
  loyaltyBalance: number
  showDollarEquivalent?: boolean
  isLoading?: boolean
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

const _LoyaltyPoints = (props: Props & InjectedProps) => {
  if (
    !props.currentCompanyStore?.company?.permissions.canAccessLoyalty &&
    !props.currentCompanyStore?.canUseExternalLoyalty
  ) {
    return <></>
  }

  const loyaltyPointsMultiplier = props.currentCompanyStore?.loyaltyPointsMultiplier

  const loyaltyCentValue = convertLoyaltyPointsToCents(
    props.loyaltyBalance,
    loyaltyPointsMultiplier,
  )

  if (props.isLoading)
    return (
      <Spin className='mr-1' size='small' indicator={<LoadingOutlined spin className='mr-1' />} />
    )

  return (
    <>
      <span>
        <span>{`${props.loyaltyBalance} point${props.loyaltyBalance === 1 ? '' : 's'}`}</span>
        {props.showDollarEquivalent && (
          <>
            <span> (</span>
            <Currency centValue={loyaltyCentValue} />
            <span>)</span>
          </>
        )}
      </span>
    </>
  )
}

export const LoyaltyPoints = inject('currentCompanyStore')(observer(_LoyaltyPoints))
